import type { FormikValues } from 'formik';
import * as Yup from 'yup';
import {
  validateLatitudeDms,
  validateLongitudeDms,
} from '../../../../utils/validation-helpers.utils';

export interface NearbyVesselsFormValues extends FormikValues {
  radius: number;
  timeSinceLastAIS: number;
  centrePoint: {
    latitude: string;
    longitude: string;
  };
}

export const defaultValues: NearbyVesselsFormValues = {
  radius: 50,
  timeSinceLastAIS: 24,
  centrePoint: { latitude: '', longitude: '' },
};

export const validationSchema = Yup.object().shape({
  radius: Yup.number()
    .typeError('Radius must be a number')
    .required('Radius is required')
    .max(100, 'Radius must not exceed 100nm'),
  timeSinceLastAIS: Yup.number()
    .typeError('Time since last AIS ping must be a number')
    .required('Time since last AIS ping is required')
    .max(24, 'Time since last AIS ping must not exceed 24 hours'),
  centrePoint: Yup.object().shape({
    latitude: validateLatitudeDms(),
    longitude: validateLongitudeDms(),
  }),
});
